module.exports = __webpack_public_path__ + "media/components/assets/img/bg/cloud-light-46502619668bdb0b2c9361fb56c0a099.svg";